exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dndlist select{height:300px!important;overflow:auto}.dndlistavailable,.dndlistselected{float:left;margin-top:10px}.dnlist .card{width:48%}.dndlistbuttons{float:left;width:4%;padding-top:80px;text-align:center}.dndlistbuttons .btn{display:block;width:30px;margin-top:10px}.dndlistbuttons .disabled{color:gray}.draggabletb{overflow:auto;height:300px;padding:0}.list-group-item{padding:0 1.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a84ffb6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/channel/Form.vue
// module id = 351
// module chunks = 0